import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NbAuthJWTToken, NbAuthResult, NbAuthService } from "@nebular/auth";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

const STRATEGY_EMAIL = "email";

@Injectable({
  providedIn: 'root'
})
export class RequestTokenService {
  private token: NbAuthJWTToken = null;

  constructor(private authService: NbAuthService) {
    this.authService.onTokenChange()
    .subscribe((token: NbAuthJWTToken) => {
      if (token && token.isValid()) {
        this.token = token;
      } else {
        this.token = null;
      }
    });
   }

  createAuthorizationHeader(): HttpHeaders {
    
    if (!this.token) {      
      // Tentar obter token atual do authService
      this.authService.getToken().subscribe((token: NbAuthJWTToken) => {
        if (token && token.isValid()) {
          this.token = token;
        } else {
          return new HttpHeaders();
        }
      });
    }

    if (!this.token || !this.token.isValid()) {
      return new HttpHeaders();
    }

    
    const raw = this.token.getValue();
    // API (JwtBearer) exige o esquema "Bearer "; valor armazenado pelo Nebular é só o JWT
    const authorization = raw.startsWith('Bearer ') ? raw : `Bearer ${raw}`;
    return new HttpHeaders().set('Authorization', authorization);
  }

  renovarToken(): Observable<NbAuthResult> {
    return this.authService.getToken().pipe(
      switchMap((token: NbAuthJWTToken) => {
        const raw = token?.getValue?.();
        if (raw == null || String(raw).trim() === "") {
          return of(
            new NbAuthResult(false, undefined, null, ["Sem token armazenado"], []),
          );
        }
        const jwt = raw.replace(/^Bearer\s+/i, "").trim();
        const login = this.obterLoginParaRefresh(jwt);
        if (!login) {
          return of(
            new NbAuthResult(
              false,
              undefined,
              null,
              ["Não foi possível identificar o usuário para renovar a sessão."],
              [],
            ),
          );
        }
        return this.authService.refreshToken(STRATEGY_EMAIL, { login, token: jwt });
      }),
    );
  }

  private obterLoginParaRefresh(jwt: string): string | null {
    const fromSession = sessionStorage.getItem("emailUsuario");
    if (fromSession && fromSession.trim()) {
      return fromSession.trim();
    }
    try {
      const parts = jwt.split(".");
      if (parts.length < 2) {
        return null;
      }
      const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(atob(base64));
      const email = payload.emailUsuario ?? payload.email;
      return typeof email === "string" ? email.trim() : null;
    } catch {
      return null;
    }
  }
}
